import { Button, Modal } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

interface BulkInactivateConfirmationModalProps {
  isOpen: boolean;
  toggle: () => void;
  count: number;
  loading: boolean;
  onConfirm: () => void;
}

const BulkInactivateConfirmationModal = ({
  isOpen,
  toggle,
  count,
  loading,
  onConfirm,
}: BulkInactivateConfirmationModalProps) => {
  const prefix = 'studentStatus.bulkInactivate';
  const { t } = useTranslation();

  const isEmpty = count === 0;

  return (
    <Modal
      isOpen={isOpen}
      toggle={loading ? () => undefined : toggle}
      size="md"
    >
      <Row className="pb-4">
        <Col xs={12} className="text-center">
          <h1 className="text-dark fs-22">
            {t(`${prefix}.confirmation.title`)}
          </h1>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <p className="fs-16 fw-300 text-center pb-3">
            {isEmpty
              ? t(`${prefix}.confirmation.noResults`)
              : t(`${prefix}.confirmation.body`, { count })}
          </p>
        </Col>
      </Row>

      <Row className="pb-2 pt-4">
        <Col xs={12} sm={6}>
          <Button
            onClick={toggle}
            text={t(`${prefix}.actions.cancel`)}
            outlined
            fullwidth
            disabled={loading}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Button
            onClick={onConfirm}
            text={t(`${prefix}.actions.confirm`)}
            fullwidth
            disabled={isEmpty || loading}
            loading={loading}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default BulkInactivateConfirmationModal;
